import React from 'react';

import { useTranslation } from 'react-i18next';

import HoleAsset from '@pkg/assets/images/hole.png';

import { Typography } from '../../../../DesignSystem';

import { EmptyGroupWrapper } from './styles';

export const EmptyGroup = () => {
    const { t: translate } = useTranslation(['groups']);
    return (
        <EmptyGroupWrapper>
            <img alt="empty group" src={HoleAsset} />
            <Typography type="label">{translate('pods_no_content')}</Typography>
        </EmptyGroupWrapper>
    );
};
